import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      const to = loc.state?.from?.pathname || "/crm";
      nav(to, { replace: true });
    } catch (ex) {
      const d = ex.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-sm panel p-6">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-6 h-6 bg-white"></div>
          <div>
            <div className="text-sm font-medium tracking-tight">Thick &amp; Thin Media</div>
            <div className="text-xs text-neutral-500">Sales operating system</div>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="text-xs text-neutral-500 block mb-1">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 rounded border text-sm"
              placeholder="you@thickandthin.media"
              required
            />
          </div>
          <div>
            <label className="text-xs text-neutral-500 block mb-1">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 rounded border text-sm"
              required
            />
          </div>
          {err && <div className="text-xs text-red-500" data-testid="login-error">{err}</div>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={busy}
            className="btn btn-primary w-full justify-center"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="mt-6 pt-4 border-t text-[11px] text-neutral-600">
          JWT HS256 · 12h session · admin-controlled access
        </div>
      </div>
    </div>
  );
}
